import { ArrowUpRight } from 'lucide-react';
import { useLang } from '@/i18n/LanguageContext';
import { SITE } from '@/content/site';
import MaskLines from '@/components/MaskLines';

export default function Contact() {
  const { t } = useLang();
  return (
    <>
      <section id="contact" className="px-5 pt-32 pb-28 md:px-10 md:pt-44 md:pb-36" data-testid="section-contact">
        <p className="font-mono-label text-[var(--pz-green)]">{t.contact.kicker}</p>
        <h2 className="font-display mt-8 text-[15.5vw] md:text-[11.5vw]">
          <MaskLines lines={[t.contact.lineA]} />
          <span className="text-[var(--pz-green)]">
            <MaskLines lines={[t.contact.lineB]} delay={0.15} />
          </span>
        </h2>
        <p className="font-mono-label mt-8 text-white/55">{t.contact.sub}</p>

        <div className="mt-16 flex flex-wrap gap-5">
          <ContactBox testId="contact-telegram-button" href={SITE.telegram.url} label={t.contact.cta} external />
          <ContactBox testId="contact-email-button" href={`mailto:${SITE.email}`} label={t.contact.mail} />
        </div>
        <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 font-mono-label" data-testid="contact-details">
          <a href={SITE.telegram.url} target="_blank" rel="noopener noreferrer" className="link-underline text-white/70 hover:text-white">
            <span className="text-white/40">TELEGRAM — </span>
            <span className="normal-case tracking-normal">{SITE.telegram.handle}</span>
          </a>
          <a href={`mailto:${SITE.email}`} className="link-underline text-white/70 hover:text-white">
            <span className="text-white/40">EMAIL — </span>
            <span className="normal-case tracking-normal">{SITE.email}</span>
          </a>
        </div>
      </section>

      <footer id="social" className="border-t hairline" data-testid="footer">
        <p className="font-mono-label px-5 pt-10 pb-4 text-[var(--pz-green)] md:px-10">{t.social.kicker}</p>
        <ul>
          {SITE.socials.map((s) => (
            <li key={s.id} className="border-b hairline">
              <a
                data-testid={`footer-social-${s.id}`}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center justify-between px-5 py-6 md:px-10 md:py-8"
                aria-label={s.label}
              >
                <span className="font-display text-3xl transition-all duration-300 group-hover:translate-x-3 group-hover:text-[var(--pz-green)] md:text-6xl">
                  {s.label}
                </span>
                <ArrowUpRight className="text-white/50 transition-all duration-300 group-hover:rotate-45 group-hover:text-[var(--pz-green)]" size={34} />
              </a>
            </li>
          ))}
        </ul>
        <div className="flex flex-col items-start justify-between gap-4 px-5 py-10 md:flex-row md:items-center md:px-10">
          <img src="/assets/LogoBlack.png" alt="PANOZ4U" className="h-5 w-auto" />
          <p className="font-mono-label text-white/45">{SITE.tagline}</p>
          <p className="font-mono-label text-white/45">© {new Date().getFullYear()} {t.footer.rights}</p>
        </div>
      </footer>
    </>
  );
}

function ContactBox({ testId, href, label, external = false }) {
  return (
    <a
      data-testid={testId}
      href={href}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      className="group inline-flex items-center gap-5 border border-[var(--pz-green)] px-8 py-6 transition-all duration-300 hover:bg-[var(--pz-green)] md:px-12"
    >
      <span className="font-display text-xl transition-colors duration-300 group-hover:text-black md:text-3xl">{label}</span>
      <ArrowUpRight className="text-[var(--pz-green)] transition-all duration-300 group-hover:rotate-45 group-hover:text-black" size={30} />
    </a>
  );
}
